export const sampleNewsList = [
  {
    id: 1,
    title: "İlk Castle Siege War 500 TL Değerinde!",
    date: "12 Eylül 2019",
    type: "haber",
    detail:
      "Yayıncı Oğuzhan Dalgakıran dengesini kaybedip 12. kattaki evinin balkonundan düşerek hayatını kaybetti. Son mesajında halsiz ve bitkin olduğunu ifade eden Dalgakıran, Sanırım hem Fenerbahçe hem yoğun yayın serisi beni yordu diye yazdı. Son yayınında ise izleyenlerine Öpüyorum hepinizi dostlarım, Allah'a emanet olun. Hepinize iyi geceler diliyorum, seviliyorsunuz diye veda ettiği ortaya çıktı.",
    image: "/assets/upload/tournament/clan.jpg",
    detail2:
      "Yayıncı Oğuzhan Dalgakıran dengesini kaybedip 12. kattaki evinin balkonundan düşerek hayatını kaybetti. Son mesajında halsiz ve bitkin olduğunu ifade eden Dalgakıran, Sanırım hem Fenerbahçe hem yoğun yayın serisi beni yordu diye yazdı. Son yayınında ise izleyenlerine Öpüyorum hepinizi dostlarım, Allah'a emanet olun. Hepinize iyi geceler diliyorum, seviliyorsunuz diye veda ettiği ortaya çıktı.",
    image2: "/assets/upload/tournament/clan.jpg",
    detail3:
      "Yayıncı Oğuzhan Dalgakıran dengesini kaybedip 12. kattaki evinin balkonundan düşerek hayatını kaybetti. Son mesajında halsiz ve bitkin olduğunu ifade eden Dalgakıran, Sanırım hem Fenerbahçe hem yoğun yayın serisi beni yordu diye yazdı. Son yayınında ise izleyenlerine Öpüyorum hepinizi dostlarım, Allah'a emanet olun. Hepinize iyi geceler diliyorum, seviliyorsunuz diye veda ettiği ortaya çıktı.",
    image3: "/assets/upload/tournament/clan.jpg",
  },
  {
    id: 2,
    title: "2. Castle Siege War 1500 TL Değerinde!",
    date: "12 Eylül 2019",
    type: "haber",
    detail: "Merhabalar nasılsın bu bir haber sayfası örneği",
  },
  {
    id: 3,
    title: "Açık Beta Karus ve Human 4 Job NP Birincilerine 100 TL Hediye!",
    date: "11 Eylül 2019",
    type: "duyuru",
    detail: "Merhabalar nasılsın bu bir duyuru sayfası örneği",
  },
  {
    id: 4,
    title: "Yeni Dark Juraid Mountain Sizlerle!",
    date: "07 Eylül 2019",
    type: "etkinlik",
    detail: "Merhabalar nasılsın bu bir etkinlik sayfası örneği",
  },
  {
    id: 5,
    title: "İlk Lunar War ile Birlikte Dragon Shelller Sizlerle!",
    date: "07 Eylül 2019",
    type: "guncelleme",
    detail: "Merhabalar nasılsın bu bir güncelleme sayfası örneği",
  },
  {
    id: 6,
    title: "Sunucu Bakım Çalışması Tamamlandı",
    date: "15 Ekim 2019",
    type: "guncelleme",
    detail: "Bakım çalışması başarıyla tamamlandı, sunucu tekrar aktif.",
  },
  {
    id: 7,
    title: "Cadılar Bayramı Etkinliği Başladı!",
    date: "25 Ekim 2019",
    type: "etkinlik",
    detail: "Cadılar Bayramı temalı etkinlikler sizi bekliyor.",
  },
  {
    id: 8,
    title: "Noel Özel Turnuvası!",
    date: "20 Aralık 2019",
    type: "etkinlik",
    detail: "Noel özel turnuvası ile büyük ödüller kazanabilirsiniz.",
  },
  {
    id: 9,
    title: "Yeni Karakter Kostümleri Eklendi",
    date: "10 Ocak 2020",
    type: "guncelleme",
    detail: "Oyun mağazasına yeni yıl kostümleri eklendi.",
  },
  {
    id: 10,
    title: "Yılın İlk Castle Siege War Etkinliği!",
    date: "15 Ocak 2020",
    type: "haber",
    detail: "Yeni yılın ilk Castle Siege War etkinliği büyük ilgi gördü.",
  },
  {
    id: 11,
    title: "Sunucu Nüfusu Rekor Kırdı!",
    date: "28 Şubat 2020",
    type: "haber",
    detail: "Sunucuya aynı anda 5000 oyuncu giriş yaptı.",
  },
  {
    id: 12,
    title: "Özel 14 Şubat Sevgililer Günü Etkinliği",
    date: "14 Şubat 2020",
    type: "etkinlik",
    detail: "Sevgililer gününe özel hediyeler kazanın.",
  },
  {
    id: 13,
    title: "Sunucu Güvenlik Güncellemesi",
    date: "05 Mart 2020",
    type: "guncelleme",
    detail: "Sunucu güvenliği artırıldı, hatalar giderildi.",
  },
  {
    id: 14,
    title: "Ramazan Özel Oyun İçi İndirimleri",
    date: "23 Nisan 2020",
    type: "duyuru",
    detail: "Ramazan ayında oyun içi mağazada indirimler başladı.",
  },
  {
    id: 15,
    title: "Bayram Etkinlikleri Başladı",
    date: "24 Mayıs 2020",
    type: "etkinlik",
    detail: "Bayram boyunca sürecek etkinlikler başladı.",
  },
  {
    id: 16,
    title: "Sunucu Kapasitesi Artırıldı",
    date: "10 Haziran 2020",
    type: "haber",
    detail: "Daha fazla oyuncu aynı anda bağlanabilecek.",
  },
  {
    id: 17,
    title: "Yeni Harita: Ice Cavern",
    date: "15 Temmuz 2020",
    type: "guncelleme",
    detail: "Oyuna yeni bir harita eklendi: Ice Cavern.",
  },
  {
    id: 18,
    title: "Özel Yaz Festivali Başladı!",
    date: "01 Ağustos 2020",
    type: "etkinlik",
    detail: "Yaz festivali boyunca eğlenceli görevler sizi bekliyor.",
  },
  {
    id: 19,
    title: "Oyuncu Sayısı 10.000'i Aştı!",
    date: "05 Eylül 2020",
    type: "haber",
    detail: "Sunucumuzda aynı anda 10.000 aktif oyuncu!",
  },
  {
    id: 20,
    title: "Kış Etkinlikleri ve Hediyeler",
    date: "10 Aralık 2020",
    type: "etkinlik",
    detail:
      "Yayıncı Oğuzhan Dalgakıran dengesini kaybedip 12. kattaki evinin balkonundan düşerek hayatını kaybetti. Son mesajında halsiz ve bitkin olduğunu ifade eden Dalgakıran, Sanırım hem Fenerbahçe hem yoğun yayın serisi beni yordu diye yazdı. Son yayınında ise izleyenlerine Öpüyorum hepinizi dostlarım, Allah'a emanet olun. Hepinize iyi geceler diliyorum, seviliyorsunuz diye veda ettiği ortaya çıktı.",
  },
  {
    id: 21,
    title: "Kurban Özel Oyun İçi İndirimleri",
    date: "25 Nisan 2020",
    type: "duyuru",
    detail: "Kurban ayında oyun içi mağazada indirimler başladı.",
    image: "/assets/upload/tournament/clan.jpg",
  },
];
